import { Injectable } from '@angular/core';
import { StorageService } from '@ebootis/utilities';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../../components/configuration-select/configuration.service';
import { LogisticsAreaProxies } from '../../../services/Ebootis.Queries/LogisticsAreaProxies';
import { LogisticsAreaType } from '../../../services/Ebootis.Shared/LogisticsAreaType';
@Injectable({
	providedIn: 'root'
})
export class LogisticAreaService {
	private readonly ZBS_AREA_PREFIX = 'ZBSarea_';
	constructor(
		private m_logisticAreaProxies: LogisticsAreaProxies,
		private storageService: StorageService,
		private cfg: ConfigurationService
	) { }

	public setLogisticArea(p_type: LogisticsAreaType, p_oid: string) {
		this.storageService.setItem('session', this.cfg.SelectedConfigOid + '/' + this.ZBS_AREA_PREFIX + p_type.toString(), p_oid);
	}

	public getLogisticArea(p_type: LogisticsAreaType): string {
		return this.storageService.getItem('session', this.cfg.SelectedConfigOid + '/' + this.ZBS_AREA_PREFIX + p_type.toString());
	}

	/**
	 * Liefert das Ergebnis des Queries für LogisticsAreaProxies zurück.
	 * @param p_params Parameter für LogisticsAreaProxies
	 */
	public getLogisticAreas(p_params: LogisticsAreaProxies.Params): Observable<LogisticsAreaProxies.Result[]> {
		return this.m_logisticAreaProxies.query(p_params);
	}

	/**
	 * Entfernt die aktuell ausgewählte LogisticArea aus dem SessionStorage.
	 */
	public removeLogisticArea(p_type?: LogisticsAreaType): void {
		if (p_type) {
			this.storageService.removeItem('session', this.cfg.SelectedConfigOid + '/' + this.ZBS_AREA_PREFIX + p_type.toString());
		} else {
			this.storageService.removeItem('session', this.cfg.SelectedConfigOid + '/' + this.ZBS_AREA_PREFIX + LogisticsAreaType.UNDEF.toString());
			this.storageService.removeItem('session', this.cfg.SelectedConfigOid + '/' + this.ZBS_AREA_PREFIX + LogisticsAreaType.ARTICLE.toString());
			this.storageService.removeItem('session', this.cfg.SelectedConfigOid + '/' + this.ZBS_AREA_PREFIX + LogisticsAreaType.CUSTOMER.toString());
		}
	}
}
